export default "__VITE_ASSET__CT$UvIAD__"